import {
  isMobile,
  gameConfigStore,
  userSettingsStore,
  BOG_LINE_GAME_TYPES,
  freeBetStore,
  betStore,
} from '@pascal/pascal-core';

import { gameName } from '../../enums';
import { resizeGameHandler } from '../../helpers';
import { registerApis } from '../../services/apiRegistration';
import { gameLiveConnection, gameService, soundService } from '../../services';
import { liveConnection } from '../liveConnection';
import { doBetStore, gameStore, roundTimeStore, wheelStore } from '../../store';

export const init = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    gameService,
    soundService,
    liveConnection,
    gameLiveConnection,
  });
  registerApis();
  gameConfigStore.initGameConfigs(
    {
      sectionCount: 1,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.ONLY_MARKET,
        isUsedPlatformIntegrationLogic: true,
      },
      isUsedBogLineComponents: true,
      initPlatformMessageConfigs: true,
      isAllSectionWithCashOutButton: false,
      isUsedInputValidationFunctionality: true,
      isUsedRoundStartAndFinishedLogicAfterCashOut: false,
      isUsedStakeUpdateLogic: true,
      isUsedRoundStartAndFinishedLogicSyncWithGameAnimations: true,
    },
    {
      onGameTypeChangeCallback: () => {
        doBetStore.setReBetData([]);
        roundTimeStore.resetRoundTimeData();
        wheelStore.setWheelResult(null);
        wheelStore.setWheelResultsHistory([]);
        gameStore.setIsBetsClosed(false);
        betStore.setLiveBets([]);
        doBetStore.setWinAmount('');
        freeBetStore.resetActiveFreeBet();
      },
      onFreeBetDeactivateCallback: () => {
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
        gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
      },
      onFreeBetActivateCallback: () => {
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
      },
      onFreeBetEndedCallback: () => {
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
      },
    }
  );
};
